import logo from './logo.svg';
import './App.css';
import React from 'react';
import { useState } from "react";
import Sidebar from './components/sidebar/sidebar';
import { BrowserRouter as Router, Routes, Route,useNavigate } from 'react-router-dom';
import Login from './pages/Login/Login';
import Services from './pages/services/services';
import Contact from './pages/contact/contact';
import Chat from './pages/chat/chat'; // Import the Chat component
// import Browny from './pages/browny-v1.0/index';



function hello (name)  {
  const extraname = name
  console.log(extraname)
  return `Hello World! ${extraname}`;
}

function MainApp() {

  // State to hold the name input
  const [name, setName] = useState('');
  const navigate = useNavigate();

   // Handler for input change
   const handleInputChange = (event) => {
    setName(event.target.value);
  };
  const handleSignOut = () => {
    navigate('/'); // Redirect to the login page
  };

  const greeting = hello(name);

  return (
    <div className="App">
      <Sidebar /> {/* Add the Sidebar component */}
      <div className="services-content">
      <header className="App-header">
      <button onClick={handleSignOut} style={{ right: '20px', padding: '10px', fontSize: '16px' }}>
          Sign Out
        </button>
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <input
          type="text"
          placeholder="Enter your name"
          value={name}
          onChange={handleInputChange}
          style={{ padding: '10px', fontSize: '16px', marginBottom: '20px' }}
        />
        
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn Reactdasdas
          <p>{greeting}</p> 

        </a>
        {/* this butten will redirect to login page an event handler is used which is handleSignOut which intern use navigate libreary to direct the paga to  login */}
        
      </header>

      </div>
    </div>
  );
}

function App () {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/app" element={<MainApp />} />
        <Route path="/services" element={<Services />} /> {/* Add Services route */}
        <Route path="/chat" element={<Chat />} /> {/* Add Chat route */}
        <Route path='/portfolio' element = { <iframe
                src="/browny/index.html"
                style={{ width: '100%', height: '100vh', border: 'none' }}
                title="Browny"
              />} />
      </Routes>
    </Router>
  );

}

export default App;
